<template>
  <div class="pageBox pageBox-role zzlContainer">
    <div class="zzlCover">
      <div class="zzlTitle">
        导航配置
      </div>
      <div class="contents moduleThree"  v-show="isModule === 'moduleThree'">
        <div class="zzlSearch">
          <div class="leftSearch"></div>
          <div class="rightSearch">
            <div class="fr">
              <el-button size="medium" round class="zzlPrimary" @click.prevent="addNavTreeNode(navTreeData.nav_content);navForm.superior = '系统菜单'">添加导航</el-button>
            </div>
          </div>
        </div>
        <div class="navTreeContent">
          <div class="treeLeft">
            <div class="title zzl-title">
              导航列表
            </div>
            <div class="content">
              <el-tree
                :data="navTreeData.nav_content"
                node-key="id"
                ref="navTree"
                draggable
                @node-drop="handleDrop"
                @node-click="navNodeClick"
                :props="navDefaultProps">
              <span class="custom-tree-node clearfix" slot-scope="{ node, data }">
                <span class="fl">{{ node.label }}</span>
                <span class="fr">
                  <el-button
                    type="text"
                    size="mini"
                    @click.stop="() => addNavTreeNode(data)">
                    添加
                  </el-button>
                    <el-button
                      type="text"
                      size="mini"
                      @click.stop="() => updateData(data,node)">
                      修改
                  </el-button>
                  <el-button
                    type="text"
                    size="mini"
                    @click.stop="() => remove(node, data)">
                    删除
                  </el-button>
                </span>
              </span>
              </el-tree>
            </div>
          </div>
          <div class="treeRight">
            <div class="title zzl-title">
              导航内容
            </div>
            <div class="content">
              <el-form label-position="left" :rules="navFormRules" ref="navForm" :model="navForm" label-width="80px">
                <el-form-item prop="superior" label="上级">
                  <el-input v-model="navForm.superior" placeholder="上级" disabled></el-input>
                </el-form-item>
                <el-form-item prop="idNumber" label="ID">
                  <el-input v-model="navForm.idNumber" placeholder="ID" :disabled="disabledForm"></el-input>
                </el-form-item>
                <el-form-item prop="name" label="名称">
                  <el-input v-model="navForm.name" placeholder="名称" :disabled="disabledForm"></el-input>
                </el-form-item>
                <el-form-item prop="url" label="URL">
                  <el-input v-model="navForm.url" placeholder="URL" :disabled="disabledForm"></el-input>
                </el-form-item>
                <el-form-item prop="ActionType" label="URL">
                  <el-radio-group v-model="navForm.ActionType">
                    <el-radio label="extlink">外部链接</el-radio>
                    <el-radio label="route">内部路由</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item prop="name" label="图标">
                  <el-input @click.native="selectIcon" readonly v-model="navForm.icon" placeholder="图标" :disabled="disabledForm">
                    <el-tooltip slot="append" class="item" effect="dark" content="选择图标" placement="top">
                      <el-button @click.native="selectIcon">
                        <svg class="icon" aria-hidden="true"><use :xlink:href="'#zion-task'"></use></svg>
                      </el-button>
                    </el-tooltip>
                  </el-input>
                </el-form-item>
                <el-form-item v-show="!disabledForm">
                  <div style="text-align: center;">
                    <el-button size="medium" round @click.prevent="cancelAll">取 消</el-button>
                    <el-button size="medium" round class="zzlPrimary" @click.prevent="confirmAll('navForm')">确 认</el-button>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--icon选择-->
    <el-dialog
      title="图标列表"
      :visible.sync="iconModal"
      center
      append-to-body
      width="80%"
      top="5vh"
      custom-class="zzlDialog"
      @close="closeIconModel"
      :close-on-press-escape="false"
      :close-on-click-modal="false">
      <div class="iconBox">
        <ul class="icon-list">
          <li 
            v-for="(item, index) in $store.state.iconList" 
            :key="'iconList' + index" 
            @click="iconClick(item, index)" :class="{'active' : iconNum === index}"
            @dblclick="confirmIcon">
            <span>
              <i v-if="isEl(item)" :class="item"></i>
              <svg v-else class="icon" aria-hidden="true"><use :xlink:href="'#' + item"></use></svg>
              <span class="icon-name">{{item}}</span>
            </span>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" round @click.prevent="closeIconModel">取 消</el-button>
        <el-button size="medium" round class="zzlPrimary" @click="confirmIcon">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import hashes from '../../../static/js/hashes.min'
  export default {
    name: 'NavigationConfiguration',
    data () {
      return {
        isModule: 'moduleThree',
        
        navDefaultProps: {
          id: 'Id',
          children: 'Children',
          label: 'Title'
        },
        
        permissionsParams: [], // 权限参数
        navTreeData: {
          nav_content: [],
          id:0,
          name: 'main',
          description:'',
          title: 'A'
        }, // 导航管理
        navForm: {
          superior: '',
          idNumber: '',
          name: '',
          icon: '',
          url: '',
          ActionType: ''
        }, // 导航的form
        navFormRules: {
          idNumber: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          icon: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ]
        }, // 导航的form的规则
        disabledForm: true, // 禁用表单
        iconModal: false, // icon模态框
        confirmIconValue: '', // 当前选择的icon
        iconNum: -1, // icon的下标
        parentData: [],
        addOrUpdateNum: -1,
        
      }
    },
    methods: {
      isEl(el) {
        return el.split('-')[0] === 'el'
      },
      // 拖拽节点
      handleDrop (a,b,c,d) {
        console.log(a,b,c,d);
        if (c==='inner') {
          for (let item of this.navTreeData.nav_content) {
            if (b.label===item.Title) {
                item.IsFolder=true
            }
        }
        }

        for (let item of this.navTreeData.nav_content) {
            if (item.Children.length===0) {
                item.IsFolder=false
            }else{
                item.IsFolder=true
            }
        }


        
        this.updateNav()
      },
      // 确定
      confirmAll (formName) {
        this.$refs[formName].validate(async valid => {
          if (valid) {
            if (this.addOrUpdateNum === 1) {
              let newChild = { Id: this.navForm.idNumber, Title: this.navForm.name, Children: [], IsFolder: false, Action: this.navForm.url, IconClass: this.navForm.icon, ActionType: this.navForm.ActionType };
              if (this.parentData.Children) {
                this.parentData.IsFolder=true
                this.parentData.Children.push(newChild);
              } else {
                this.parentData.push(newChild);
              }
            } else {
              this.parentData.Title = this.navForm.name;
              this.parentData.Id = this.navForm.idNumber;
              this.parentData.IconClass = this.navForm.icon;
              this.parentData.Action = this.navForm.url;
              this.parentData.ActionType = this.navForm.ActionType;
            }
            await this.updateNav()
          }
        })
      },
      // 修改导航
      async updateNav () {
        const res = await this.zzlHttp.post(this.zzlApi.updateNav, this.navTreeData);
        if (res.code === 0) {
          this.disabledForm = true;
          this.selectNavNode({});
          this.$message.success('操作成功');
        } else {
          await this.getNavTreeManage();
          this.$message.error('操作失败');
        }
      },
      // 取消
      cancelAll () {
        this.disabledForm = true;
        this.selectNavNode({})
      },
      // icon点击
      iconClick (_data, _num) {
        this.confirmIconValue = _data;
        this.iconNum = _num;
      },
      // 确认选择图标
      confirmIcon () {
        if (this.confirmIconValue !== '') {
          this.navForm.icon = this.confirmIconValue;
          this.iconModal = false
        } else {
          this.$message.warning('请选择一个图标')
        }
      },
      // 关闭图标模态款
      closeIconModel () {
        this.iconModal = false
      },
      // 选择图标
      selectIcon () {
        if (!this.disabledForm) {
          this.iconNum = -1;
          this.iconModal = true
        } else {
          this.$message.warning('请先点击添加或修改')
        }
      },
      // 添加导航
      addNavTreeNode (_data) {
        this.addOrUpdateNum = 1;
        this.parentData = _data;
        this.disabledForm = false;
        this.selectNavNode({})
        this.navForm.superior = _data.Title;
      },
      // navTree点击改变展示数据
      navNodeClick (data, Node) {
        this.disabledForm = true;
        this.selectNavNode(data, Node)
      },
      // 修改数据
      updateData (data, Node) {
        this.addOrUpdateNum = 2;
        this.disabledForm = false;
        this.parentData = data;
        this.selectNavNode(data, Node)
        
      },
      // 删除导航
      async remove(node, data) {
        this.$confirm('您正在执行删除操作', '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(async () => {
          const parent = node.parent;
          const children = parent.data.Children || parent.data;
          const index = children.findIndex(d => d.Id === data.Id);
          children.splice(index, 1);
          await this.updateNav()
        }).catch(() => {})
      },
      // 右边内容显示数据
      selectNavNode (data, Node = null) {
        if (Node === null) {
          this.navForm.superior = '系统菜单';
        } else if (Node.parent.data.Title) {
          this.navForm.superior = Node.parent.data.Title;
        } else {
          this.navForm.superior = '系统菜单';
        }
        this.navForm.name = data.Title;
        this.navForm.idNumber = data.Id;
        this.navForm.icon = data.IconClass;
        this.navForm.url = data.Action;
        this.navForm.ActionType = data.ActionType;
      },
      // 获取导航管理导航
      async getNavTreeManage () {
        const res = await this.zzlHttp.post(
          this.zzlApi.getNavTreeManage,
          { 
            navname:'main'
          }
        )
        if (res.code === 0 && res.data.nav_content) {
          this.navTreeData.nav_content = res.data.nav_content;
          this.navTreeData.id=res.data.id;
        }
      },
      // 树权限改变
      async treeChange (data, checked) {
        
      },
      
      // 重置
      reset (_refName) {
        
        this.$refs[_refName].resetFields();
      },
    
      // 关闭模态框
      closeRoleModal () {
        this.$refs.tree.setCheckedNodes([]);
      },
     
      
     
    },
    async mounted () {
      this.disabledForm = true;
      await this.getNavTreeManage();
      // await this.selectNavNode(this.navTreeData.data[0]);
    }
  }
</script>

<style scoped lang="scss">
  .iconBox{
    max-height: 70vh;
    overflow: auto;

    .operation{
      button{
        margin: 10px 10px 10px 0;
      }
    }
    .title{
      padding: 14px 18px;
      background-color: #f8f8f8;
      border-bottom: solid 1px #e6e6e6;
      margin-bottom: 28px;
      i{
        font-size: 12px;
      }
    }
    ul{
      overflow: hidden;
      list-style: none;
      padding: 0;
      margin: 0 28px;
      border: 1px solid #eaeefb;
      border-radius: 4px;
      li{
        float: left;
        width: 12.5%;
        text-align: center;
        height: 120px;
        line-height: 120px;
        color: #666;
        font-size: 13px;
        transition: color .15s linear;
        border-right: 1px solid #eee;
        border-bottom: 1px solid #eee;
        margin-right: -1px;
        margin-bottom: -1px;
        cursor: pointer;
        span{
          display: inline-block;
          line-height: normal;
          vertical-align: middle;
          font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;
          color: #99a9bf;
          i{
            display: block;
            font-size: 32px;
            margin-bottom: 15px;
            color: #606266;
          }
          svg{
            display: block;
            font-size: 32px;
            margin: 0 auto 15px;
            color: #606266;
          }
        }
        .icon-name{
          display: inline-block;
          padding: 0 3px;
          height: 1em;
          color: #606266;
        }
      }
      li:hover, li:focus{
        color: #fff;
        background-color: #6adac5;
        border-color: #07c29e;
        i{
          color: #fff;
        }
        .icon-name{
          color: #fff;
        }
      }
      li.active{
        color: #fff;
        background-color: #6adac5;
        border-color: #07c29e;
        i{
          color: #fff;
        }
        .icon-name{
          color: #fff;
        }
      }
    }
  }
  .inputItem{
    position: relative;
    padding-right: 12px;
    .authorizationBox{
      width: 100%;
      height: 285px;
      padding: 8px 12px;
      overflow: auto;
      border: solid 1px #e6e6e6;
    }
    span.smTip{
      position: absolute;
      top: 11px;
      left: 74px;
      font-size: 12px;
      color: #bcc0c4;
    }
    span.selectAll{
      position: absolute;
      top: 11px;
      right: 12px;
      font-size: 12px;
      text-decoration: underline;
      color: #07c29e;
      cursor: pointer;
    }
  }
  .addOrUpdate {
    .title {
      padding: 13px 20px 12px;
      background-color: #f8f8f8;
      border-bottom: solid 1px #e6e6e6;
      font-size: 14px;
      font-weight: bold;
      line-height: 14px;
      color: #45494d;
      i{
        font-size: 12px;
      }
      i:hover {
        color: #07c29e;
        cursor: pointer;
      }
    }
    .formBox{
      padding: 20px;
    }
    .operation{
      padding: 0 20px 22px;
      button{
        margin-left: 12px;
      }
    }
  }
  .margin21{
    margin-top: 21px;
  }
  .pageBox{
    .titleButton{
      padding: 12px 17px 0;
      border-bottom: 1px solid #e6e6e6;
      margin-bottom: 20px;
      line-height: 23px;
      color: #07c29e;
      span{
        padding: 0 8px 6px;
        border-bottom: 3px solid transparent;
        margin-right: 20px;
        color: #555a5e;
        cursor: pointer;
        i{
          font-size: 16px;
          margin-right: 8px;
        }
      }
      span.active{
        color: #07c29e;
        border-bottom-color: #07c29e;
      }
    }
    .contents{
      min-height: calc(100vh - 148px);
      .tableList{
        overflow: auto;
        i {
          font-size: 16px;
          margin-right: 28px;
          &:last-child{
             margin-right: 0;
           }
          &:hover {
             color: #07c29e;
           }
        }
      }
    }
    .moduleThree{
      .navTreeContent{
        position: relative;
        .treeLeft {
          width: 400px;
          height: calc(100vh - 246px);
          overflow: auto;
          border: solid 1px #e6e6e6;
          border-radius: 3px;
          .title{
            padding: 12px 18px;
            background-color: #f8f8f8;
            border-bottom: solid 1px #e6e6e6;
          }
          .content{
            padding: 10px;
          }
          .custom-tree-node{
            display: flex;
            justify-content: space-between;
            width: 100%;
            line-height: 28px;
          }
          &::-webkit-scrollbar {
             width: 4px;
          }
          &::-webkit-scrollbar-track {
             background-color: #f1f1f1;
          }
          &::-webkit-scrollbar-track-piece {
             background-color: #f1f1f1;
             border-radius: 10px;
             -webkit-border-radius: 10px;
          }
          &::-webkit-scrollbar-thumb {
             background-color: #ccc;
             border: solid 1px #f1f1f1;
             border-radius: 10px;
          }
          &::-webkit-scrollbar-corner {
             background-color: #f1f1f1;
          }
          &::-webkit-resizer {
             background-repeat: no-repeat;
             background-position: bottom right;
          }
          &::-webkit-scrollbar-thumb:hover {
             background-color: #323c48;
          }
        }
        .treeRight{
          position: absolute;
          left: 410px;
          top: 0;
          right: 0;
          bottom: 0;
          overflow: auto;
          border: solid 1px #e6e6e6;
          border-radius: 3px;
          .title{
            padding: 12px 18px;
            background-color: #f8f8f8;
            border-bottom: solid 1px #e6e6e6;
          }
          .content{
            padding: 10px 40px;
          }
          &::-webkit-scrollbar {
             width: 4px;
          }
          &::-webkit-scrollbar-track {
             background-color: #f1f1f1;
          }
          &::-webkit-scrollbar-track-piece {
             background-color: #f1f1f1;
             border-radius: 10px;
             -webkit-border-radius: 10px;
          }
          &::-webkit-scrollbar-thumb {
             background-color: #ccc;
             border: solid 1px #f1f1f1;
             border-radius: 10px;
          }
          &::-webkit-scrollbar-corner {
             background-color: #f1f1f1;
          }
          &::-webkit-resizer {
             background-repeat: no-repeat;
             background-position: bottom right;
          }
          &::-webkit-scrollbar-thumb:hover {
             background-color: #323c48;
          }
        }
      }
    }
  }
</style>
